import React, { useEffect } from "react"
import CaseHeader from "../../features/case-header"
import TechnologiesList from "../../features/technologies-list"
import HelloLogo from "../../assets/images/technologies/hello.svg"
import HallwayLogo from "../../assets/images/technologies/hallway.svg"
import PedNetLogo from "../../assets/images/technologies/pednet.svg"
import CraftLogo from "../../assets/images/technologies/craft.svg"
import CaseProjectBlock from "../../features/case-project-block"
import { PROJECT_QUARKWORKS } from "../../data/cases/project-data"
import CasesSays from "../../features/cases-client"
import { OUR_CLIENTS } from "../../data/home/our-clients"
import { QUARKWORKS } from "../../data/cases/seo-says"
import { HEADER_QUARKWORKS } from "../../data/cases/headers-data"
import { OtherCases } from "../../features/other-cases"
import { OurCases } from "../../features/our-cases"
import { QUARKWORKS_CASES } from "../../data/cases/quarkworks-cases"
import { Gallery } from "../../features/gallery"
import { useMediaQuery } from "react-responsive"
import { DESKTOP_WIDTH } from "../../constants/common"
import "./index.scss"
import { Helmet } from "react-helmet-async"

const Quarkworks = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const isDesktop = useMediaQuery({ minWidth: DESKTOP_WIDTH })

    return (
        <>
            <Helmet defer={false}>
                <title>Newsoft - Quarkworks</title>
            </Helmet>
            <div className="quarkworks">
                <CaseHeader {...HEADER_QUARKWORKS} />
                <div className="try-now-image">
                    <img
                        src="https://s3.amazonaws.com/staging.newsoft-website-v2/media/home/our_cases_quarkworks.webp"
                        alt="Quarkworks main"
                    />
                </div>
                <TechnologiesList
                    title="Projects"
                    className={"technologies-horizontal"}
                >
                    <img
                        src={HallwayLogo}
                        alt="Hallway logo"
                        style={isDesktop ? { width: "177px" } : {}}
                    />
                    <img
                        src={HelloLogo}
                        alt="Hello logo"
                        style={isDesktop ? { width: "83px" } : {}}
                    />
                    <img
                        src={PedNetLogo}
                        alt="Pednet logo"
                        style={isDesktop ? { width: "131px" } : {}}
                    />
                    <img
                        src={CraftLogo}
                        alt="Craft logo"
                        style={isDesktop ? { width: "143px" } : {}}
                    />
                </TechnologiesList>
                <CaseProjectBlock {...PROJECT_QUARKWORKS} client={true} />
                <CasesSays
                    data={OUR_CLIENTS[0]}
                    header="What our client says"
                />
                <OurCases
                    cases={QUARKWORKS_CASES}
                    header="Successfully delivered cases"
                    mobHeader="Cases"
                />
                <CasesSays
                    more
                    ceo={true}
                    data={QUARKWORKS}
                    header="What our CEO says"
                />
            </div>
            <Gallery />
            <div className="quarkworks">
                <OtherCases currentCase="/cases/quarkworks" />
            </div>
        </>
    )
}

export default Quarkworks
